import { useTranslation } from "react-i18next";
import { Droplets, Sun, Sunrise, Sunset, Wind } from "lucide-react";
import { conditionOf, humidityLevel, uvLevel, windLevel } from "./weatherMeta";

export { conditionOf };

const TILE_3D = {
  boxShadow:
    "0 10px 18px rgba(0,0,0,0.24), 0 5px 7px rgba(0,0,0,0.15),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.22), inset 0 -3px 8px rgba(0,0,0,0.12)",
};

const Tile = ({ icon: Icon, label, value, hint, tone }) => (
  <div style={TILE_3D} className="rounded-xl bg-background px-2 py-1.5 text-center transition-transform duration-300 hover:-translate-y-0.5">
    <p className="flex items-center justify-center gap-1 text-xs font-bold text-muted-foreground">
      <Icon className={`h-3.5 w-3.5 shrink-0 ${tone}`} />
      <span>{label}</span>
      <span className="font-mono text-sm font-black text-foreground">{value}</span>
    </p>
    <p className={`text-[11px] font-semibold ${tone}`}>{hint}</p>
  </div>
);

// مؤشرات الطقس (رطوبة/أشعة/ريح) وشريط الشروق والغروب.
export const WeatherTiles = ({ weather }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="mt-2.5 grid grid-cols-3 gap-2">
        <Tile icon={Droplets} label={t("weather.humidity")} value={`${weather.humidity}%`} tone="text-sky-400"
          hint={t(`weather.level.humidity.${humidityLevel(weather.humidity)}`)} />
        <Tile icon={Sun} label={t("weather.uvShort")} value={weather.uv} tone="text-amber-500"
          hint={t(`weather.level.uv.${uvLevel(weather.uv)}`)} />
        <Tile icon={Wind} label={t("weather.windShort")} value={weather.wind} tone="text-primary"
          hint={t(`weather.level.wind.${windLevel(weather.wind)}`)} />
      </div>

      <div className="mt-2.5 flex items-center justify-between gap-2 text-xs font-bold text-muted-foreground">
        <span className="flex items-center gap-1">
          <Sunrise className="h-3.5 w-3.5 text-amber-500" /> {weather.sunrise}
        </span>
        <div className="relative h-1 flex-1 rounded-full bg-primary/15">
          <span className="absolute -top-1 start-0 h-3 w-3 rounded-full bg-amber-500" />
          <span className="absolute -top-1 end-0 h-3 w-3 rounded-full bg-orange-500" />
        </div>
        <span className="flex items-center gap-1">
          {weather.sunset} <Sunset className="h-3.5 w-3.5 text-orange-500" />
        </span>
      </div>
    </>
  );
};
